import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// Import the Menu icon from lucide-react
import { Flower, Menu, X } from 'lucide-react';

function Navbar() {
    const location = useLocation();

    // 1. STATE: Tracks if the mobile menu is open (default: false)
    const [isOpen, setIsOpen] = useState(false);

    const isHomePage = location.pathname === '/';

    // Determine the text/icon color based on homepage state
    const iconColor = isHomePage ? 'white' : '#5F7161';

    return (
        // Note: I replaced 'navbar' with 'nav-default' to match your other CSS
        <nav className={`nav-wrapper ${isHomePage ? 'nav-transparent' : 'nav-default'}`}>
            <Link to="/" className="nav-logo-link">
                <div className="nav-logo-container">
                    <Flower color={iconColor} size={32} />
                    <h2 style={{color: iconColor}}>La On Massage</h2>
                </div>
            </Link>

            {/* 2. MOBILE TOGGLE BUTTON */}
            <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
                {/* Show X icon when open, Menu icon when closed */}
                {isOpen ? <X color={iconColor} size={32} /> : <Menu color={iconColor} size={32} />}
            </button>

            {/* 3. MENU LIST: Apply 'open' class when state is true */}
            <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
                <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
                <li><Link to="/services" onClick={() => setIsOpen(false)}>Services</Link></li>
                <li><Link to="/contact" onClick={() => setIsOpen(false)}>Book Now</Link></li>
            </ul>
        </nav>
    );
}

export default Navbar;